import datadog from '@ilg-core/analytics/datadog'
import type { AnalyticsProvider } from '../types'

export const datadogProvider: AnalyticsProvider = {
  name: 'datadog',

  logEvent(
    eventName: string,
    eventParameters?: Record<string, string | number>
  ) {
    datadog.log.info(eventName, eventParameters)
  },

  logError(
    eventName: string,
    eventParameters?: Record<string, string | number>
  ) {
    datadog.log.error(eventName, {
      ...eventParameters,
      statusMessage: eventName,
    })
  },
}
